import React from 'react';

import { di } from 'react-magnetic-di';

import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { Build } from '../../types';
import { getCurrentBuild, isFullyBuilt } from '../../utils';
import { AgentFooterActions } from '../capabilities/agent/footer-actions';
import { AppFooterActions } from '../capabilities/app/footer-actions';
import { AutomationFooterActions } from '../capabilities/automation/footer-actions';
import { useSolutionPlan } from '../solution-plan-context';

const styles = cssMap({
	container: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
});

type CapabilityFooterActionsProps = { build: Build };

const CapabilityFooterActions = ({ build }: CapabilityFooterActionsProps) => {
	switch (build.type) {
		case 'ROVO_AGENT':
			return <AgentFooterActions build={build} />;
		case 'ECOSYSTEM_APP':
			return <AppFooterActions build={build} />;
		case 'AUTOMATION_RULE':
			return <AutomationFooterActions build={build} />;
	}
};

export const CardFooter = (): React.JSX.Element | null => {
	di(useSolutionPlan);

	const { builds, currentBuildNumber } = useSolutionPlan();
	const currentBuild = getCurrentBuild(builds, currentBuildNumber);

	if (isFullyBuilt(builds)) {
		return null;
	}

	return (
		<Flex gap="space.100" xcss={styles.container}>
			<CapabilityFooterActions build={currentBuild} />
		</Flex>
	);
};
